import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H3, Title1 } from "@components/Typography";
import { usePerformanceChart, useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";
import { formatCurrency, formatGrossReturns } from "@utils";
import { styles } from "./styles";

export const PerformanceChartHeader = () => {
  const { theme } = useTheme();

  const { data, selectedChart } = usePerformanceChart();

  const nodes = data.oneDay.nodes;

  const difference = selectedChart.difference;
  const percentage = selectedChart.percentage;

  const change = formatGrossReturns({ difference, percentage });

  const color = (() => {
    if (difference > 0) {
      return theme.investment.breakdown.card.positive;
    } else if (difference < 0) {
      return theme.investment.breakdown.card.negative;
    } else {
      return theme.investment.breakdown.card.neutral;
    }
  })();

  const amountValue = (() => {
    if (nodes.length === 0) {
      return 0;
    }

    return nodes[nodes.length - 1].value;
  })();

  const amount = formatCurrency(amountValue, true);

  return (
    <>
      <Spacing size={SpacingSizes.L} />

      <div style={styles.container}>
        <H3>{i18n.t(Translations.PerformanceChartTitle)}</H3>
        <Spacing size={SpacingSizes.XS} />

        <Title1>{amount}</Title1>
        <Spacing size={SpacingSizes.XS} />

        <Body style={{ ...styles.change, color }}>{change}</Body>
      </div>

      <Spacing size={SpacingSizes.M} />
    </>
  );
};
